import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useTopeDelPlan from './useTopeDelPlan';

/**
 * Aviso permanente de la bandeja cuando el plan llegó a su tope de mensajes (20-oct-2026). La lectura
 * y la decisión están en `useTopeDelPlan` / `utils/bannerTopeDelPlan.js`; esto sólo pinta.
 */
export default function BannerTopeDelPlan({ context }) {
  const { t } = useTranslation('chats');
  if (!useTopeDelPlan(context).mostrar) return null;
  return (
    <div role="alert" data-testid="banner-tope-del-plan" style={{ background: '#fff4e5', border: '1px solid #f0b46c', color: '#7a4b00', borderRadius: '8px', padding: '0.75rem 1rem', marginBottom: '1rem', fontSize: '14px' }}>
      {t('bannerTope.texto')}{' '}
      <Link to="/billing" style={{ color: '#7a4b00', fontWeight: 600 }}>{t('bannerTope.enlace')}</Link>
    </div>
  );
}
